import HTTP from './http-common';

const listDropdownBrand = () => HTTP.get("/brand/dropdown");
const listDropdownBranch = () => HTTP.get("/branch/dropdown");
const listDropdownModel = (brandCode) => HTTP.get("/model/dropdown/" + brandCode);
const listDropdownColor = (brandCode) => HTTP.get("/color/dropdown/" + brandCode);
const listDropdownSupplier = () => HTTP.get("/supplier/dropdown");
const listDropdownConsumableType = () => new Promise((resolve) => {
            resolve(
                [
                    {'name': 'วัสดุสิ้นเปลืองในงานซ่อม', 'value': 'S'},
                    {'name': 'วัสดุสิ้นเปลือง (ส่วนรวม)', 'value': 'A'},
                    {'name': 'วัสดุสำนักงาน', 'value': 'O'},
                    {'name': 'ยาสามัญ', 'value': 'D'},
                    {'name': 'สี', 'value': 'C'}
                ]
            );   
        });
const listDropdownConsumable = () => HTTP.get("/consumable/dropdown/false");
const listDropdownConsumableColor = (supplierCode) => HTTP.get("/consumable/dropdown/true?supplierCode=" + supplierCode);
export {
    listDropdownBrand,
    listDropdownModel,
    listDropdownColor,
    listDropdownSupplier,
    listDropdownConsumableType,
    listDropdownConsumable,
    listDropdownConsumableColor,
    listDropdownBranch
}